<template>
  <div>
    <a-row>
      <a-col :span="2" />
      <a-col :span="20">
        <div>
          <p>
            菜单标题： <a-input v-model="title" style="width: 400px" /> 文档标题： <a-input v-model="doc_title" style="width: 400px; margin-right: 10px" />
            <a-button @click="finishUpdate">保存编辑内容</a-button>
          </p>
          <div>
            视频上传：
            <a-upload :before-upload="beforeUpload" :showUploadList="false">
              <a-button> <a-icon type="upload" /> Select File </a-button>
            </a-upload>
            <span v-if="data.video_url" style="display: inline-block; padding-left: 20px; cursor: pointer" @click="openVideo">
              当前视频 : {{ data.video_url }}</span
            >
            <span v-else style="display: inline-block; padding-left: 20px"> 暂无视频</span>
          </div>
        </div>
        <quill-editor ref="editor" :height="600" style="margin-top: 10px" />
      </a-col>
      <a-col :span="2" />
    </a-row>
  </div>
</template>

<script>
import { getDocContent, updateDocContent } from '@/api/docmenu'
import { getUploadToken } from '@/api/common'
import quillEditor from '@/components/QuillEditor'
import axios from 'axios'
import moment from 'moment'
export default {
  components: { quillEditor },
  data() {
    return {
      id: this.$route.query.id,
      title: '',
      doc_title: '',
      data: {}
    }
  },
  created() {
    getDocContent({ id: Number(this.id) }).then(res => {
      this.data = res.data[0]
      this.$refs.editor.setContent(this.data.content)
      this.title = this.data.menu_title
      this.doc_title = this.data.doc_title
    })
  },
  methods: {
    finishUpdate() {
      if (!this.title || !this.doc_title) {
        this.$message.warning('标题不能为空', 2)
        return
      }
      if (this.loadVideo) {
        this.$message.warning('视频上传完成后才能保存', 2)
        return
      }
      const params = {
        id: this.data.id,
        menu_id: this.data.menu_id,
        title: this.title,
        doc_title: this.doc_title,
        content: this.$refs.editor.getContent(),
        video_url: this.data.video_url
      }
      updateDocContent(params).then(() => {
        this.$message.success(`'更新成功`, 2)
        this.$router.push({ name: 'DocManage' })
      })
    },
    beforeUpload(file) {
      const hide = this.$message.loading('正在上传中，请稍候', 0)
      this.loadVideo = true
      getUploadToken().then(res => {
        const aliyunOssToken = res
        var formData = new FormData()
        formData.append('key', moment().unix() + file.name) // 存储在oss的文件路径
        formData.append('OSSAccessKeyId', aliyunOssToken.accessid) // accessKeyId
        formData.append('policy', aliyunOssToken.policy) // policy
        formData.append('Signature', aliyunOssToken.signature) // 签名
        // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
        formData.append('file', file)
        formData.append('success_action_status', 200) // 成功后返回的操作码
        var url = aliyunOssToken.host
        const fileUrl = aliyunOssToken.host + '/' + aliyunOssToken.dir + moment().unix() + file.name
        // var fileUrl = aliyunOssToken.host + '/' + aliyunOssToken.dir + file.name
        axios
          .post(url, formData, { headers: { 'Content-Type': 'application/form-data' } })
          .then(() => {
            hide()
            this.$message.success('上传成功')
            this.$set(this.data, 'video_url', fileUrl)
            this.loadVideo = false
          })
          .catch(() => {
            hide()
            this.$message.success('上传失败')
            this.loadVideo = false
          })
      })
      return false
    },
    openVideo() {
      window.open(this.data.video_url)
    }
  }
}
</script>

<style scoped>
.editor-button-box {
  position: relative;
  top: 82px;
  display: flex;
  justify-content: center;
}
</style>
